// `kitchen.ticket.created` / `kitchen.ticket.updated` on `venue:{id}:kitchen` (spec/09 §3, §6.3;
// F-FNB-04). The live push the food-and-kitchen foundation deferred (ADR-0020): a ticket's changes —
// built from an order, advanced, recalled or cancelled — reach the venue's **kitchen display** and,
// through the player tracker, the kiosk and app (spec/12 §7.6).
//
// Each frame carries the whole ticket (its lines, its preparation station, where it delivers and its
// state), so the display applies it to the card it already shows without a refetch. A member subscribes
// to `venue:{id}:kitchen` only with `kitchen:read` (the gateway checks it, spec/09 §3); the REST
// snapshot (`GET …/kitchen/tickets`) remains the recovery mechanism (spec/09 §4), so a dropped frame
// converges on the next read rather than drifting.
//
// The frames ride the outbox dispatcher's realtime sink (`kitchen/realtime.ts`), not the gateway's
// floor coalescer, so they carry no per-channel `version` yet: the version-sequenced delivery is the
// follow-on shared with the floor's counter. The station client (C#) does not read these — they are a
// console/app message — so they are not in `REALTIME_JSON_SCHEMAS`.
import { z } from "../zod.js";
import { KitchenTicketSchema } from "../routes/kitchen.js";
import { KITCHEN_TICKET_CREATED, KITCHEN_TICKET_UPDATED } from "./constants.js";
import { realtimeMessage } from "./envelope.js";
export { KITCHEN_TICKET_CREATED, KITCHEN_TICKET_UPDATED };
/** The payload both frames carry: the ticket as the display renders it (spec/09 §6.3). */
export const KitchenTicketEventPayloadSchema = z
    .object({ ticket: KitchenTicketSchema })
    .openapi('KitchenTicketEventPayload', {
    description: 'A kitchen ticket changed: the whole ticket, to apply to the display (spec/09 §6.3).',
});
/** A ticket was built for an order (F-FNB-04). */
export const KitchenTicketCreatedMessage = realtimeMessage('evt', KITCHEN_TICKET_CREATED, KitchenTicketEventPayloadSchema);
/** A ticket advanced, was recalled, or was cancelled (F-FNB-04). */
export const KitchenTicketUpdatedMessage = realtimeMessage('evt', KITCHEN_TICKET_UPDATED, KitchenTicketEventPayloadSchema);
//# sourceMappingURL=kitchen.js.map